import { gql } from "@apollo/client";

export const GET_CATEGORIES_IN_FOCUS = gql`
  query getCategoriesInFocus {
    getMultipleCategories {
      id
      name
      url
      url_key
      url_path
      image
      subcategories {
        items {
          id
          name
          url
          url_key
          url_path
          image
        }
        total_count
      }
      products {
        items {
          id
          name
          sku
          url
          url_key
          url_path
          image {
            url
            label
          }
        }
        total_count
      }
    }
  }
`;

export default {
  getCategoriesInFocusQuery: GET_CATEGORIES_IN_FOCUS,
};
